module.exports = __webpack_public_path__ + "img/1_026.1e7ee2d4.jpg";